import React from "react";

interface DividerWithTextProps {
  text: string;
}

const DividerWithText: React.FC<DividerWithTextProps> = ({ text }) => {
  return (
    <div className="my-6 flex items-center">
      <div aria-hidden="true" className="flex-1 border-t border-gray-200" />
      <div className="relative flex justify-center px-2">
        <span className="text-sm font-normal text-gray-400">{text}</span>
      </div>
      <div aria-hidden="true" className="flex-1 border-t border-gray-200" />
    </div>
  );
};

export default DividerWithText;
